import styled from "styled-components";

export default styled.div`
	color: var(--text);
`;
